import React, { useEffect, useState } from "react";
import HomeSection from "./HomeSection";
import Feature from "./Feature";
import AboutSection from "./AboutSection";
import Mentors from "./Mentors";
import BlogSection from "./BlogSection";
import VisionSection from "./VisionSection";
import MisionSection from "./MisionSection";
import TestimonialSection from "./TestimonialSection";
import TeamSection from "./TeamSection";
import FounderMessage from "./FounderMessage";
import Scholarship from "./Scholarship";
import axios from "axios";
import swal from "sweetalert";
import { FaTimes } from "react-icons/fa";
import NewsSection from "./NewsSection";

const Home = () => {
  const [settingPermission, setSettingPermission] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });
  const [cmsData, setCmsData] = useState([]);
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);

  //block Mouse right click,copy,pest//
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();

    const handleCopyCutPaste = (e) => e.preventDefault();

    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Tab") {
        e.preventDefault();
        return false;
      }
      if (e.altKey && e.key === "Tab") {
        e.preventDefault();
        return false;
      }
      if (
        (e.ctrlKey && ["c", "v", "x"].includes(e.key.toLowerCase())) ||
        e.key === "PrintScreen" ||
        e.key === "F12"
      ) {
        e.preventDefault();
        return false;
      }
    };

    // Add Event Listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("copy", handleCopyCutPaste);
    document.addEventListener("cut", handleCopyCutPaste);
    document.addEventListener("paste", handleCopyCutPaste);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("copy", handleCopyCutPaste);
      document.removeEventListener("cut", handleCopyCutPaste);
      document.removeEventListener("paste", handleCopyCutPaste);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // ✅ Validation function
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      tempErrors.name = "Name is required";
      isValid = false;
    }

    if (!formData.email) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Invalid email format";
      isValid = false;
    }

    if (!formData.mobile) {
      tempErrors.mobile = "Phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      tempErrors.mobile = "Enter valid 10-digit phone number";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // ✅ Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/student-contact`,
        formData
      );

      if (res.data.success == 1) {
        swal({
          title: "Message Sent!",
          text: "Thank you for contacting us.",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        localStorage.setItem("hasSeenModal", "true");
        setShow(false);
        setFormData({ name: "", mobile: "", email: "" });
        setErrors({});
      } else {
        swal("Error", res.data.message || "Failed to send message", "error");
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const fetchSiteSettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setSettingPermission(response.data.data);
    } catch (error) {
      console.error("Failed to fetch site settings:", error);
    }
  };
  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data);
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
  const studentContactCMS = cmsData.find(
    (item) => item.type === "website_popup"
  );
  useEffect(() => {
    fetchCMSData();
  }, []);
  useEffect(() => {
    fetchSiteSettings();
  }, []);

  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenModal");
    if (!hasSeenModal) {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      {settingPermission?.bannerpermission === 1 && <HomeSection />}
      <Feature />
      <AboutSection />
      <FounderMessage />
      {/* <Scholarship /> */}
      <Mentors />
      {settingPermission?.teacherpermission === 1 && <TeamSection />}
      <VisionSection />
      <MisionSection />
      <TestimonialSection />
      <NewsSection />
      {settingPermission?.blogpermission === 1 && <BlogSection />}

      {/* Modal */}
      {settingPermission?.student_contact_model === 1 && show && (
        <div className="modal-overlay">
          <div className="custom-modal">
            <button className="close-btn" onClick={handleClose}>
              <FaTimes />
            </button>
            {/*<style>
                {`
               .imagepopup::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
      background: url("${imagePath}${
                studentContactCMS.image || ""
              }") no-repeat center center / cover;
                  opacity: 1;
                  background-size: cover;
                  z-index: -1;
                  filter: blur(2px);
                  }
              `}
            </style>*/}
            {studentContactCMS && (
              <>
                <div className="modal-content">
                  <div className="modal-left imagepopup">
                    {/* <img
                      src={`${
                        imagePath?.endsWith("/") ? imagePath : imagePath + "/"
                      }${studentContactCMS.image}`}
                      alt={studentContactCMS.name}
                      className="img-fluid rounded about_img"
                    /> */}
                    <img
                      src={`${imagePath}${studentContactCMS.image || ""}`}
                      alt={studentContactCMS.name}
                      className="img-fluid rounded about_img"
                    />
                  </div>
                  <div className="modal-right">
                    <h2>{studentContactCMS.name}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: studentContactCMS.description || "",
                      }}
                    ></p>
                  </div>
                </div>

                <div className="query_form">
                  <form className="popup-form" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      className={`form-control ${
                        errors.name ? "is-invalid" : ""
                      }`}
                      placeholder="Name"
                      name="name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />

                    <input
                      type="email"
                      className={`form-control ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Email"
                      name="email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />

                    <input
                      type="tel"
                      className={`form-control ${
                        errors.mobile ? "is-invalid" : ""
                      }`}
                      placeholder="Phone Number"
                      name="mobile"
                      value={formData.mobile}
                      maxLength={10}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setFormData({ ...formData, [e.target.name]: value });
                      }}
                    />

                    <button type="submit" className="educate-btn">
                      <span className="educate-btn__curve"></span>
                      Submit
                    </button>
                  </form>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
